// from general.js
/* global dcAnalytics */


(function () {
    $(function () {
        // Disable comma
        $('body').on('keydown', 'input#amount', function (e) {
            if (e.which === 188) { // Comma key's keycode
                e.preventDefault();
            }
        });
    });
})();

$(function () {
    $('input[name=foo]').on('change', function () {
        $('.js-other-amount-entry').toggle($('#amount7').prop('checked'));

        if (this.value !== 'other') {
            $('#other-amount').val(this.value);
        } else if (this.value === 'other') {
            $('#other-amount').val('').focus();
        }
    });
    $('.js-other-amount-entry').hide();
});

$(document).ready(function () {
    addEventHandlers();
    function addEventHandlers() {
        $('.js-add-account-credits').on('click', function () {
            dcAnalytics.trackEventGA(['Cart - Add Account Credit', 'Save']);
        });
    }
});
